import { Component } from './styled';
/**
 * Groups related form field components with consistent vertical spacing.
 *
 * Renders a semantic `<fieldset>` element, so the `disabled` prop disables
 * all contained inputs at once via native HTML behavior.
 *
 * @example
 * <Fieldset>
 *     <TextField name="firstName" />
 *     <TextField name="lastName" />
 * </Fieldset>
 */
export function Fieldset(props) {
    const { disabled, children } = props;
    return <Component disabled={disabled}>{children}</Component>;
}
